import PropTypes from 'prop-types';
import {
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  Build as BuildIcon,
} from '@material-ui/icons';
import Slider from '@material-ui/core/Slider';
import {
  Button,
  Grid,
  Toolbar,
  Box,
  Typography,
  Tooltip,
  Chip,
} from '@material-ui/core';
import {grey} from '@material-ui/core/colors';
import {useStyles} from 'Utility/styles';

export default function ScheduleNavigator(props) {
  const {
    onClickChangeStep,
    schedule,
    scheduleSteps,
    slideChange,
    selectedStepNumber,
  } = props;
  const classes = useStyles();
  const valueText = (value) => `step: ${value}`;

  return (
    <Grid item md={12}>
      <Toolbar className={classes.greyToolbar}>
        <Typography className={classes.spacer} variant={'h5'}>
          {schedule.title}
        </Typography>
        <Chip
          className={classes.chip}
          style={{marginLeft: 10}}
          label={schedule.team.name}
          component="a"
          href={`/#/Schedules?scheduleTeamFilterText=${schedule.team.name}`}
          clickable
        />
        <Tooltip title="Work In Progress">
          <BuildIcon style={{marginLeft: 10, color: grey[500]}} />
        </Tooltip>
      </Toolbar>
      <Grid item xl={12}></Grid>
      <Grid item md={12} style={{marginRight: 25, marginLeft: 25}}>
        <Slider
          value={selectedStepNumber + 1 || 1}
          onChange={slideChange}
          defaultValue={1}
          getAriaValueText={valueText}
          aria-labelledby="horizontal-slider"
          valueLabelDisplay="auto"
          marks={true}
          min={1}
          max={scheduleSteps.length}
        />
      </Grid>
      <Box textAlign="center">
        <Button
          style={{marginTop: 7, marginRight: 7}}
          variant="outlined"
          color="primary"
          startIcon={<SkipPreviousIcon />}
          onClick={() =>
            onClickChangeStep(selectedStepNumber, -selectedStepNumber)
          }
        >
          First Step
        </Button>
        <Button
          style={{marginTop: 7, marginRight: 7}}
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIosIcon />}
          onClick={() => onClickChangeStep(selectedStepNumber, -1)}
        >
          Back step
        </Button>
        <Button
          style={{marginTop: 7, marginRight: 7}}
          variant="outlined"
          color="primary"
          endIcon={<ArrowForwardIosIcon />}
          onClick={() => onClickChangeStep(selectedStepNumber, 1)}
        >
          Next step
        </Button>
        <Button
          style={{marginTop: 7, marginRight: 7}}
          variant="outlined"
          color="primary"
          endIcon={<SkipNextIcon />}
          onClick={() =>
            onClickChangeStep(
              selectedStepNumber,
              scheduleSteps.length - selectedStepNumber - 1,
            )
          }
        >
          Last step
        </Button>
      </Box>
    </Grid>
  );
}

ScheduleNavigator.propTypes = {
  schedule: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    team: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  scheduleSteps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ).isRequired,
  onSelectStep: PropTypes.func.isRequired,
  slideChange: PropTypes.func.isRequired,
  onClickChangeStep: PropTypes.func.isRequired,
  selectedStepNumber: PropTypes.number.isRequired,
};
